import axios from "axios";
import { API_URL } from '../Constants';

class ClientInstanceService {
    checkValidInstance(instanceName) {
        return axios.get(`${API_URL}checkInstanceName/${instanceName}`);
    };

    loginUser(credentials) {
        return axios.post(`${API_URL}console/login`, credentials);
    };

    googleLogin(googleCredential) {
        return axios.post(`${API_URL}console/google-login`, googleCredential);
    };

    createInstance(instanceData) {
        return axios.post(`${API_URL}console/registerTenant`, instanceData);
    };

    // COMMUNICATION CHANNELS
    getCommunicationChannels(tenantID, accessToken) {
        return axios.get(`${API_URL}console/comm-channels/${tenantID}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    addCommunicationChannel(tenantID, channelData, accessToken) {
        console.log('Adding communication channel:', channelData);
        return axios.post(`${API_URL}console/comm-channels/${tenantID}`, channelData, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    deleteCommunicationChannel(tenantID, channelID, type, accessToken) {
        return axios.delete(`${API_URL}console/comm-channels/${tenantID}/${channelID}/${type}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    updateCommunicationChannel(tenantID, channelID, type, channelData, accessToken) {
        return axios.put(`${API_URL}console/comm-channels/${tenantID}/${channelID}/${type}`, channelData, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    testCommunicationChannel(tenantID, channelID, type, accessToken) {
        return axios.post(`${API_URL}console/test-comm-channel/${tenantID}/${channelID}/${type}`, {}, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    // HISTORY
    getHistoryLogs(tenantID, accessToken, filterObject) {
        return axios.post(`${API_URL}console/complete-history/${tenantID}`, filterObject, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    markFollowedUp(tenantID, accessToken, historyId, userId, notes) {
        return axios.post(`${API_URL}console/mark-history-followed-up/${tenantID}/${historyId}`, { userId, notes }, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    markRequiringFollowUp(tenantID, accessToken, historyId, userId, notes) {
        return axios.post(`${API_URL}console/mark-history-requiring-follow-up/${tenantID}/${historyId}`, { userId, notes }, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    }

    // CONTEXT
    getTenantContext(tenantID, accessToken) {
        console.log('Fetching tenant context for:', tenantID);
        return axios.get(`${API_URL}console/tenant-context/${tenantID}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    createTenantContext(tenantID, contextData, accessToken) {
        return axios.post(`${API_URL}console/tenant-context/${tenantID}`, contextData, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    updateTenantContext(tenantID, contextID, contextData, accessToken) {
        return axios.put(`${API_URL}console/tenant-context/${tenantID}/${contextID}`, contextData, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    deleteTenantContext(tenantID, contextID, accessToken) {
        return axios.delete(`${API_URL}console/tenant-context/${tenantID}/${contextID}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    checkTenantContextLocation(tenantID, locationId, accessToken) {
        return axios.get(`${API_URL}console/check-tenant-context-location/${tenantID}/${locationId}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    getTenantContextLocation(tenantID, accessToken) {
        return axios.get(`${API_URL}console/tenant-context-location/${tenantID}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    createTenantContextLocation(tenantID, locationData, accessToken) {
        return axios.post(`${API_URL}console/tenant-context-location/${tenantID}`, locationData, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    checkTenantContextClient(tenantID, clientId, accessToken) {
        return axios.get(`${API_URL}console/check-tenant-context-client/${tenantID}/${clientId}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    getTenantContextClient(tenantID, accessToken) {
        return axios.get(`${API_URL}console/tenant-context-client/${tenantID}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    createTenantContextClient(tenantID, clientData, accessToken) {
        return axios.post(`${API_URL}console/tenant-context-client/${tenantID}`, clientData, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    // CALL QUEUE
    getCommunicationQueue(tenantID, accessToken) {
        return axios.get(`${API_URL}console/communication-queue/${tenantID}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    formatBulkQueueData(tenantID, accessToken, queueDataFile) {
        return axios.post(`${API_URL}console/format-communication-queue/${tenantID}`, queueDataFile, { headers: { 'Authorization': `Bearer ${accessToken}`, 'Content-Type': 'multipart/form-data' } });
    };

    addToCommunicationQueue(tenantID, userId, queueArray, accessToken) {
        return axios.post(`${API_URL}console/communication-queue/${tenantID}/${userId}`, queueArray, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    stopCommunicationQueue(tenantID, accessToken) {
        return axios.post(`${API_URL}console/stop-communication-queue/${tenantID}`, {}, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    removeFromCommunicationQueue(tenantID, queue, accessToken) {
        return axios.delete(`${API_URL}console/communication-queue/${tenantID}`, queue, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    getCommunicationQueueHistory(tenantID, queueId, accessToken) {
        return axios.get(`${API_URL}console/communication-queue-history/${tenantID}/${queueId}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    // INTEGRATIONS
    getAllIntegrations(accessToken) {
        return axios.get(`${API_URL}console/integrations`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    getIntegrations(tenantID, accessToken) {
        return axios.get(`${API_URL}console/integrations/${tenantID}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    addIntegration(tenantID, integrationData, accessToken) {
        return axios.post(`${API_URL}console/integrations/${tenantID}`, integrationData, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };

    updateIntegrations(tenantID, integrationData, accessToken) {
        return axios.put(`${API_URL}console/integrations/${tenantID}`, integrationData, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    };
};

ClientInstanceService = new ClientInstanceService();
export default ClientInstanceService;